import { render, staticRenderFns } from "./applicantTwo.vue?vue&type=template&id=dcc2b3a6"
import script from "./applicantTwo.vue?vue&type=script&lang=js"
export * from "./applicantTwo.vue?vue&type=script&lang=js"
import style0 from "./applicantTwo.vue?vue&type=style&index=0&id=dcc2b3a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports